import { AnalyticsContainer } from "@/features/deployment-dashboard";

export function AnalyticsRoute() {
  return <AnalyticsContainer />;
}
